import { TAddress } from "../../../../common/types";
import { TResourceValue, TResourceValueProductCategory } from "../../../../services/valuesManager/valuesManager";
import _ from "lodash";
import { defaultRxInformationState, RxInformationState } from "../prescriptionInformation/PrescriptionInformation";

export type DurableMedicalEquipmentProduct = {
    id: string,
    productCategory?: TResourceValueProductCategory,
    selectedProducts?: TResourceValue[],
    products?: TResourceValue[],
}

export interface IDurableMedicalEquipmentState extends RxInformationState {
    products: DurableMedicalEquipmentProduct[],
    comments: string,
    availableForRental?: string,
    prescription: boolean,
    requestedDeliveryDate?: Date,
    requestedDeliveryDateString: string,
    deliveryAddressType: 'Home' | 'Hospital' | 'Other',
    address?: TAddress,
    contactPerson: string,
    contactPhone: string,
    vendorName: string,
    vendorPhone: string,
    vendorContactName: string,
    isRush: boolean,

    productCategories?: TResourceValueProductCategory[],
    productsLoaded: boolean,
}

export const defaultDurableMedicalEquipmentState: IDurableMedicalEquipmentState = {
    products: [{ id: _.uniqueId() }],
    comments: '',
    prescription: false,
    requestedDeliveryDateString: '',
    deliveryAddressType: 'Home',
    availableForRental: '',
    contactPerson: '',
    contactPhone: '',
    vendorName: '',
    vendorPhone: '',
    vendorContactName: '',
    isRush: false,
    errors: [],
    productsLoaded: false,
    ...defaultRxInformationState
};